import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'
import { Controller } from 'core-components/library/validation'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'

import styles from './QBRErrorModal.module.scss'

interface IQBRErrorModalContentProps {
  onCloseButtonClick: () => void
  isButtonDisabled: boolean
}

export const QBRErrorModalContent = ({
  onCloseButtonClick,
  isButtonDisabled,
}: IQBRErrorModalContentProps) => {
  return (
    <Controller>
      <div className={styles.root}>
        <div className={styles.title}>
          <Translation text={TRANSLATION_KEYS.buttons.errorOccured} />
        </div>
        <div className={styles.notSavedText}>
          <Translation text={TRANSLATION_KEYS.buttons.notSaved} />
        </div>
        <div className={styles.mainText}>
          <Translation text={TRANSLATION_KEYS.buttons.errorModalMainText} />
        </div>
        <div className={styles.btnWrapper}>
          <Button onClick={onCloseButtonClick} disabled={isButtonDisabled}>
            <Translation text={TRANSLATION_KEYS.buttons.closeButton} />
          </Button>
        </div>
      </div>
    </Controller>
  )
}
